/* eslint-disable */
/**
 * NOTE: Kani nga config para ma centralized ang mga components para usa nalang katawagan
 * og ma ready to use na bisan asa paka punta to the moon.
 */

// Core Components
import Toolbar from "../components/core/Toolbar.vue";
import Navigation from "../components/core/NavigationDrawer.vue";
import Breadcrumbs from "../components/core/Breadcrumbs.vue";
import PanelHeader from "../components/core/PanelHeader.vue";
import PageFooter from "../components/core/PageFooter.vue";

//Loader Components
import DashboardBioSkeleton from "../components/loader/SkeletonBioLoader.vue";
import DashboardSkeleton from "../components/loader/SkeletonDashboardLoader.vue";
import DashboardLogsLoader from "../components/loader/SkeletonLogsLoader.vue";
import LoaderMenu from "../components/loader/SkeletonMenuLoader.vue";
import DashboardTimerSkeleton from "../components/loader/SkeletonTimeLoader.vue";
import SkeleltonChartLoader from "../components/loader/SkeleltonChartLoader.vue";

// asset imports
import "bootstrap/dist/css/bootstrap.css";
import "vue-notifyjs/themes/default.scss";
import "../assets/sass/light-bootstrap-dashboard.scss";
import "es6-promise/auto";

import Card from "src/components/UIComponents/Cards/Card.vue";

function setupComponents(Vue) {
  //Core
  Vue.component("toolbar", Toolbar);
  Vue.component("navigation", Navigation);
  Vue.component("breadcrumbs", Breadcrumbs);
  Vue.component("panel-header", PanelHeader);
  Vue.component("page-footer", PageFooter);
  //Loader
  Vue.component("loader-menu", DashboardBioSkeleton);
  Vue.component("dashboard-skeleton", DashboardSkeleton);
  Vue.component("dashboard-logs-loader", DashboardLogsLoader);
  Vue.component("loader-menu", LoaderMenu);
  Vue.component("dashboard-timer-skeleton", DashboardTimerSkeleton);
  Vue.component("chart-loader", SkeleltonChartLoader);
  Vue.component("card", Card);
}

export { setupComponents };



// WEBPACK FOOTER //
// ./src/config/setup-components.js